import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => `$${Number(n).toFixed(2)}`;

export default function ItemsTable({ S, items }) {
  return (
    <View style={S.table}>
      <View style={S.thead}>
        <Text style={[S.th, S.cNo]}>No.</Text>
        <Text style={[S.th, S.cDesc]}>Descripción</Text>
        <Text style={[S.th, S.cQty]}>Cantidad</Text>
        <Text style={[S.th, S.cPU]}>Precio Unitario</Text>
        <Text style={[S.th, S.cDU]}>Descuento Unitario</Text>
        <Text style={[S.th, S.cItbms]}>Monto ITBMS</Text>
        <Text style={[S.th, S.cItem]}>Valor Item</Text>
      </View>

      {items.map((it, idx) => (
        <View key={idx} style={S.tr}>
          <Text style={[S.td, S.cNo]}>{it.no + 1}</Text>
          <Text style={[S.td, S.cDesc]}>{it.descripcion}</Text>
          <Text style={[S.td, S.cQty]}>{it.cantidad}</Text>
          <Text style={[S.td, S.cPU]}>{money(it.precioUnitario)}</Text>
          <Text style={[S.td, S.cDU]}>{money(it.descuentoUnitario)}</Text>
          <Text style={[S.td, S.cItbms]}>{money(it.montoItbms)}</Text>
          <Text style={[S.td, S.cItem]}>{money(it.valorItem)}</Text>
        </View>
      ))}
    </View>
  );
}